export var ERRORS_CODE = {
    ERR_PHONE: 'UREG_ERR_146',
    ERR_AUTH: 'AUTH_ERR_101',
};
export var ERR_GENERIC = {
    message: 'Something went wrong. Please refresh the page and try again.',
};
export var ERR_PHONE = {
    message: 'This phone number is associated with another account. Please try another number.',
};
export var ERR_INVALID_ZIP = {
    message: 'Please provide a valid zip code.',
};
export var ERR_SAVE = {
    message: 'We’re unable to save your changes. Please try again.',
};
export var ERR_REDIRECT = {
    message: 'We’re redirecting you to sign in to your account.',
};
export var ERR_PRICING_BOOK = {
    message: 'There was an error loading the Pricing Benefits. Refresh the page and try again.',
};
